if (!customElements.get('collection-hover-video')) {
  class CollectionHoverVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.media =
        this.closest('.collection-item__media--ratio') ||
        this.closest('.collection-item__media') ||
        this.parentElement;

      if (!this.video || !this.media) return;

      this.video.muted = true;
      this.video.playsInline = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');

      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onHoverChange = this.onHoverChange.bind(this);

      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.bindHover();
      if (typeof this.hoverQuery.addEventListener === 'function') {
        this.hoverQuery.addEventListener('change', this.onHoverChange);
      } else if (typeof this.hoverQuery.addListener === 'function') {
        this.hoverQuery.addListener(this.onHoverChange);
      }
    }

    onHoverChange() {
      this.bindHover();
    }

    bindHover() {
      this.unbindHover();
      if (!this.hoverQuery?.matches) return;
      this.media.addEventListener('mouseenter', this.onEnter);
      this.media.addEventListener('mouseleave', this.onLeave);
      this.media.addEventListener('focusin', this.onEnter);
      this.media.addEventListener('focusout', this.onLeave);
    }

    unbindHover() {
      if (!this.media) return;
      this.media.removeEventListener('mouseenter', this.onEnter);
      this.media.removeEventListener('mouseleave', this.onLeave);
      this.media.removeEventListener('focusin', this.onEnter);
      this.media.removeEventListener('focusout', this.onLeave);
    }

    onEnter() {
      if (!this.video) return;
      this.classList.add('is-playing');
      this.video.muted = true;
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.classList.remove('is-playing');
        });
      }
    }

    onLeave() {
      if (!this.video) return;
      this.classList.remove('is-playing');
      try {
        this.video.pause();
        this.video.currentTime = 0;
      } catch (_error) {
        /* ignore seek errors while video is still loading */
      }
    }

    disconnectedCallback() {
      this.unbindHover();
      if (!this.hoverQuery || !this.onHoverChange) return;
      if (typeof this.hoverQuery.removeEventListener === 'function') {
        this.hoverQuery.removeEventListener('change', this.onHoverChange);
      } else if (typeof this.hoverQuery.removeListener === 'function') {
        this.hoverQuery.removeListener(this.onHoverChange);
      }
    }
  }

  customElements.define('collection-hover-video', CollectionHoverVideo);
}
